import { COSMETIC_COLLEGE_ANDROID_PLAY_STORE_URL, COSMETIC_COLLEGE_IOS_APP_STORE_URL } from "@/utils/student-app";

const SITE_ORIGIN = "https://www.cosmetic.college";

export const COSMETIC_COLLEGE_POSTAL_ADDRESS = {
  "@type": "PostalAddress",
  streetAddress: "3 Locks Court, 429 Crofton Rd",
  addressLocality: "Orpington",
  addressRegion: "Kent",
  postalCode: "BR6 8NL",
  addressCountry: "GB",
} as const;

export const COSMETIC_COLLEGE_UKPRN = "10088324";

export const COSMETIC_COLLEGE_UKPRN_IDENTIFIER = {
  "@type": "PropertyValue",
  propertyID: "UKPRN",
  value: COSMETIC_COLLEGE_UKPRN,
} as const;

export const COSMETIC_COLLEGE_GEO = {
  "@type": "GeoCoordinates",
  latitude: 51.3663,
  longitude: 0.0519,
} as const;

export const COSMETIC_COLLEGE_TELEPHONE = "+443330155117";

export const COSMETIC_COLLEGE_SAME_AS = [
  "https://g.page/r/CUF0YJ0tdY97EB0",
  "https://maps.app.goo.gl/PWX1XQCnNWqXLD2x5",
  "https://www.google.com/maps/place/Cosmetic+College/@51.3663,0.0519,17z",
  "https://www.facebook.com/TheCosmeticCollegeUK",
  "https://www.instagram.com/thecosmeticcollege/",
  "https://www.youtube.com/channel/UCKx20vzFF9_0iVZH1cpy_KQ",
  "https://www.tiktok.com/@cosmeticcollege",
  COSMETIC_COLLEGE_ANDROID_PLAY_STORE_URL,
  COSMETIC_COLLEGE_IOS_APP_STORE_URL,
  SITE_ORIGIN,
];

type BuildLocalEntitySchemaOptions = {
  pageUrl: string;
  description: string;
  name?: string;
};

export function buildCosmeticCollegeLocalEntitySchema({
  pageUrl,
  description,
  name = "Cosmetic College",
}: BuildLocalEntitySchemaOptions) {
  const canonicalPageUrl = pageUrl.startsWith("http")
    ? pageUrl
    : `${SITE_ORIGIN}${pageUrl.startsWith("/") ? pageUrl : `/${pageUrl}`}`;

  return {
    "@context": "https://schema.org",
    "@type": ["EducationalOrganization", "LocalBusiness"],
    "@id": `${canonicalPageUrl}#cosmetic-college-orpington`,
    name,
    url: canonicalPageUrl,
    description,
    image: `${SITE_ORIGIN}/logo/cc-logo@3x.png`,
    logo: `${SITE_ORIGIN}/logo/cc-logo@3x.png`,
    telephone: COSMETIC_COLLEGE_TELEPHONE,
    priceRange: "$$",
    address: COSMETIC_COLLEGE_POSTAL_ADDRESS,
    geo: COSMETIC_COLLEGE_GEO,
    hasMap: "https://maps.app.goo.gl/PWX1XQCnNWqXLD2x5",
    areaServed: [
      { "@type": "City", name: "London" },
      { "@type": "AdministrativeArea", name: "Greater London" },
      { "@type": "AdministrativeArea", name: "Kent" },
    ],
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      opens: "10:00",
      closes: "18:00",
    },
    sameAs: COSMETIC_COLLEGE_SAME_AS,
    identifier: COSMETIC_COLLEGE_UKPRN_IDENTIFIER,
    parentOrganization: {
      "@type": "Organization",
      "@id": `${SITE_ORIGIN}/#organization`,
      name: "Cosmetic College",
      url: `${SITE_ORIGIN}/`,
      address: COSMETIC_COLLEGE_POSTAL_ADDRESS,
      identifier: COSMETIC_COLLEGE_UKPRN_IDENTIFIER,
    },
  };
}
